/* src/app/modules/concept/concept/concept.component.css */
.butonera-izquierda {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  margin: 0.5rem;
  margin-top: 1em;
  margin-bottom: 1em;
  margin-right: 5%;
  width: 100%;
  padding-right: 80px;
}
.btn-create-right {
  position: absolute !important;
  right: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin: 0 !important;
}
.import-card {
  padding: 24px;
  background-color: #fafafa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-family: "Inter Tight", sans-serif;
  margin: auto;
}
.import-card .import-header {
  text-align: center;
  margin-bottom: 16px;
}
.import-card .import-header h2 {
  color: var(--cf-chrome);
  margin-bottom: 4px;
}
.import-card .import-header p {
  color: #666;
}
.import-card .import-body {
  padding-top: 16px;
}
.import-card .import-body .template-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 16px;
}
.import-card .import-body .file-upload-wrapper {
  text-align: center;
  margin-top: 10px;
}
.import-card .import-body .file-upload-wrapper button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.import-card .import-body .file-upload-wrapper .file-name {
  display: block;
  margin-top: 8px;
  font-size: 14px;
  color: #555;
}
.import-card .spinner-container {
  text-align: center;
  padding: 20px;
}
.import-card .spinner-container p {
  margin-top: 12px;
  font-size: 16px;
  color: #555;
}
.import-card .preview-body {
  text-align: center;
  margin-top: 16px;
}
.import-card .preview-body p {
  margin-bottom: 12px;
}
.import-card .actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}
.detalle-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}
.detalle-row .mat-mdc-form-field {
  flex: 1 1 45%;
  min-width: 200px;
}
.detalle-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.separator {
  margin: 16px 0;
  border: none;
  border-top: 1px solid #ccc;
}
.preview-table {
  margin-top: 20px;
  padding: 0 16px;
}
.detalle-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: nowrap;
}
.detalle-row .mat-mdc-form-field {
  flex: 1 1 auto;
  min-width: 150px;
  max-width: 300px;
}
.detalle-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-left: auto;
}
.tarjetas-resumen {
  display: flex;
  gap: 0.75rem;
  margin: 0.75rem 0;
  justify-content: flex-start;
}
.tarjeta-coste,
.tarjeta-venta {
  flex: 1;
  max-width: 160px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}
.mat-mdc-card-content {
}
.titulo {
  margin: 0.25rem 0 0.125rem 0;
  font-size: 0.8rem;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.valor {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.1;
}
.coste-icono,
.venta-icono {
  font-size: 1.75rem;
  margin-bottom: 0.25rem;
}
.coste-icono {
  color: #f44336;
}
.venta-icono {
  color: #4caf50;
}
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  gap: 0.5rem;
}
.spinner-text {
  margin: 0;
  color: #666;
  font-size: 0.8rem;
}
@media (max-width: 768px) {
  .tarjetas-resumen {
    flex-direction: column;
  }
}
.cc-splash {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
  min-width: 300px;
}
.cc-splash__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.cc-splash__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
}
.cc-splash__dots {
  display: flex;
  gap: 8px;
}
.cc-splash__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #e3fd64;
  opacity: 0.3;
  animation: cc-pulse 1.2s ease-in-out infinite;
}
.cc-splash__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.cc-splash__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.cc-splash__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
@keyframes cc-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.cc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px 12px;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  flex-wrap: wrap;
}
.cc-header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.cc-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.cc-header__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--cf-brand-dark);
}
.cc-header__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
}
.cc-header__sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.cc-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cc-btn-example {
  font-size: 13px;
}
.cc-btn-save {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 500 !important;
}
.cc-btn-close {
  color: #9ca3af !important;
}
.cc-content {
  padding: 20px !important;
  max-height: calc(75vh - 120px) !important;
  overflow-y: auto !important;
}
.cc-toggles {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  padding: 14px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.cc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.cc-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px 2px 10px;
  border-radius: 20px;
  background: rgba(227, 253, 100, 0.1);
  border: 1px solid rgba(227, 253, 100, 0.3);
  color: #92400e;
  font-size: 12px;
  font-weight: 500;
}
.cc-chip__remove {
  background: none;
  border: none;
  cursor: pointer;
  color: #92400e;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  margin-left: 2px;
}
.cc-summary {
  margin-top: 20px;
  padding: 14px 16px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.cc-summary__label {
  margin: 0 0 10px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7280;
}
.cc-summary__row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #374151;
  padding: 3px 0;
}
.cc-summary__row--total {
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
  font-size: 14px;
  color: #1a1d23;
}
.cc-section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 20px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e7eb;
}
.cc-section-label mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #e3fd64;
}
.cc-attach-label {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.cc-attach-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 24px 0;
}
.cc-attach-iframe {
  width: 100%;
  height: 280px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 8px;
}
.cc-attach-img {
  display: block;
  width: 100%;
  height: 280px;
  object-fit: contain;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.cc-attach-hint {
  margin: 6px 0 0;
  font-size: 12px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cc-attach-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}
.cc-file-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  font-size: 13px;
  cursor: pointer;
  color: #374151;
  transition: background 0.15s;
}
.cc-file-label:hover {
  background: #f3f4f6;
}
.cc-file-label mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.cc-del-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 20px 0;
  position: relative;
}
.cc-del-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.1);
  flex-shrink: 0;
}
.cc-del-icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #dc2626;
}
.cc-del-title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.3 !important;
  color: #1a1d23;
}
.cc-del-sub {
  margin: 3px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.cc-del-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #9ca3af !important;
}
.cc-del-content {
  padding: 16px 20px !important;
}
.cc-del-msg {
  margin: 0;
  font-size: 14px;
  color: #374151;
}
.cc-del-feedback {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  background: rgba(22, 163, 74, 0.08);
  color: #166534;
}
.cc-del-feedback mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.cc-del-actions {
  padding: 8px 20px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.cc-del-btn {
  background-color: #dc2626 !important;
  color: #fff !important;
  font-weight: 500 !important;
}
.cds-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 20px 20px 0;
  position: relative;
}
.cds-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.cds-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.cds-header__title {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #1a1d23;
  line-height: 1.3 !important;
}
.cds-header__sub {
  margin: 3px 0 0;
  font-size: 12px;
  color: #6b7280;
}
.cds-close {
  position: absolute !important;
  top: 12px;
  right: 12px;
  color: #9ca3af !important;
}
.cds-content {
  padding: 16px 20px !important;
  overflow: visible !important;
}
.cds-form {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.cds-field {
  flex: 1;
  min-width: 180px;
}
.cds-actions {
  padding: 8px 20px 20px !important;
  justify-content: flex-end !important;
  gap: 8px;
}
.cds-btn-export {
  background-color: #e3fd64 !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 500 !important;
}
.cc-barcode-preview {
  display: flex;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  padding: 12px 8px;
  margin-bottom: 12px;
}
.cc-barcode-preview svg {
  max-width: 100%;
  height: auto;
}
.cc-barcode-error {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #c8002d;
  margin: -8px 0 12px;
}
.cc-barcode-error mat-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
}
/*# sourceMappingURL=concept.component.css.map */
